var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBulb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 20H10C10 21.1 9.1 22 8 22C6.9 22 6 21.1 6 20ZM4 18C4 18.55 4.45 19 5 19H11C11.55 19 12 18.55 12 18C12 17.45 11.55 17 11 17H5C4.45 17 4 17.45 4 18ZM15.5 9.5C15.5 13.32 12.84 15.36 11.73 16H4.27C3.16 15.36 0.5 13.32 0.5 9.5C0.5 5.36 3.86 2 8 2C12.14 2 15.5 5.36 15.5 9.5ZM20.37 7.37L19 8L20.37 8.63L21 10L21.63 8.63L23 8L21.63 7.37L21 6L20.37 7.37ZM18 6L18.94 3.94L21 3L18.94 2.06L18 0L17.06 2.06L15 3L17.06 3.94L18 6Z",
    fill: "#020202"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBulb);
export default __webpack_public_path__ + "static/media/bulb.fb16b168012c05b92d215f7474b71640.svg";
export { ForwardRef as ReactComponent };